<template>
  <v-container class="pa-0">
    <v-layout row class="pr-4">
      <span class="display-1 primary--text">Training Packages</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" icon flat @click.native="addTrainerPackage" v-if="trainerPackageList.length !== 0">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-divider></v-divider>
    <div v-if="trainerPackageList.length === 0" class="text-xs-center my-5">
      <v-btn @click.native="addTrainerPackage" round color="primary">Start adding Training Package</v-btn>
    </div>
    <div v-else>
      <v-card v-for="(trainerPackageEntity , index) in trainerPackageList" :key="index" class="my-4">
        <v-card-title class="grey lighten-4 py-0">
          <span class="title primary--text">
            {{trainerPackageEntity.packageTitle}}
          </span>
          <v-spacer></v-spacer>
          <v-chip small color="secondary" text-color="white">{{trainerPackageEntity.duration}} days</v-chip>
          <v-chip color="secondary" text-color="white" small>
            {{trainingTypeString(trainerPackageEntity.trainigType)}}
          </v-chip>
          <v-chip color="secondary" text-color="white" small>
            {{trainerPackageEntity.unitPrice}} INR
          </v-chip>
          <v-btn color="primary" icon flat @click.native="editTrainerPackage(trainerPackageEntity)">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <h5>Summary:</h5>
                <p>
                  {{trainerPackageEntity.packageSummary}}
                </p>
              </v-flex>
              <v-flex xs12>
                <h5>
                  Package Goals:
                </h5>
                <p>
                  {{trainerPackageEntity.packageGoals}}
                </p>
              </v-flex>
              <v-flex xs6>
                <h5 class="d-inline">Target Audience:</h5> {{trainerPackageEntity.targetAudience}}
              </v-flex>
              <v-flex xs6>
                <h5 class="d-inline">
                  Target Industry:
                </h5> {{trainerPackageEntity.targetIndustry}}
              </v-flex>
            </v-layout>
            <v-divider class="my-2"></v-divider>
            <v-layout row>
              <v-flex sm12>
                <v-subheader class="d-inline title pa-0">Course Outline</v-subheader>
                <span v-if="trainerPackageEntity.outlineDocument !== null && trainerPackageEntity.outlineDocument !== ''">
                  <v-btn color="primary" round outline @click="downloadDocument(trainerPackageEntity.outlineDocument)">Download course outline</v-btn>
                </span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex sm6>
                <h5>Key Topics:</h5>
                <p>
                  {{trainerPackageEntity.keyTopics}}
                </p>
              </v-flex>
              <v-flex sm6>
                <h5>
                  Key Skills:
                </h5>
                <p>
                  {{trainerPackageEntity.keySkills}}
                </p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex sm6>
                <h5>Assessment/Methodology:</h5>
                <p>
                  {{trainerPackageEntity.assessmentMethodology}}
                </p>
              </v-flex>
              <v-flex sm6>
                <h5>
                  Prerequisite:
                </h5>
                <p>
                  {{trainerPackageEntity.prerequisite}}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="trainerPackage.id !== null">
              <v-btn flat dark slot="activator">Delete</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline error--text">Delete Data</span>
                </v-card-title>
                <v-card-text>
                  Sure you want to delete this record?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                  <v-btn color="error" round @click.native="deleteTrainerPackage" :loading="loading" :disabled="loading">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn dark flat @click.native="saveTrainerPackage" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="trainerPackageForm" id="tpForm">
            <input type="hidden" name="id" :value="trainerPackage.id" />
            <input type="hidden" name="outlineDocument" :value="trainerPackage.outlineDocument" />
          <v-container grid-list-md>
            <v-subheader v-show="trainerPackage.id === null" class="pa-0 primary--text">
              *Add training program you frequently deliver
            </v-subheader>
            <v-layout wrap row>
              <v-flex xs12 sm4>
                <v-text-field name="packageTitle" label="Package Title" value="Input text" v-model="trainerPackage.packageTitle" :rules="rules.packageTitle" :counter="128" box required></v-text-field>
              </v-flex>
              <v-flex xs4 sm4>
                <v-text-field name="duration" type="number" label="Duration (days)" v-model="trainerPackage.duration" :rules="rules.duration" box required></v-text-field>
              </v-flex>
              <v-flex xs8 sm4>
                <v-select
                  :items="items"
                  v-model="trainerPackage.trainigType"
                  label="Trainig Type"
                  box
                  required
                  name="trainingType"
                  :rules="rules.isRequired"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field name="targetAudience" label="Target Audience " value="Input text" v-model="trainerPackage.targetAudience" :rules="rules.targetAudience" :counter="128" box required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field name="targetIndustry" label="Target Industry" value="Input text" v-model="trainerPackage.targetIndustry" :rules="rules.targetIndustry" :counter="128" box required></v-text-field>
              </v-flex>
              <v-flex xs4 sm4>
                <v-text-field name="unitPrice" label="Unit Price(INR)"
                type="number" v-model="trainerPackage.unitPrice" :rules="rules.unitPrice" box required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea name="packageSummary" rows="2" label="Package Summary" value="Input text" v-model="trainerPackage.packageSummary" :rules="rules.packageSummary" :counter="512" box required></v-textarea>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea name="packageGoals" rows="2" label="Package Goals" value="Input text" v-model="trainerPackage.packageGoals" :rules="rules.packageGoals" :counter="512" box required></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="pa-0"><h2>Course Outline</h2></v-subheader>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field name="keyTopics" label="Key Topics" value="Input text" v-model="trainerPackage.keyTopics" :rules="rules.keyTopics" :counter="128" box required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field name="keySkills" label="Key Skills" value="Input text" v-model="trainerPackage.keySkills" :rules="rules.keySkills" :counter="256" box required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-textarea name="assessmentMethodology" rows="2" label="Assessment/Methodology" value="Input text" v-model="trainerPackage.assessmentMethodology" :rules="rules.assessmentMethodology" :counter="512" box required></v-textarea>
            </v-flex>
            <v-flex xs12 sm6>
              <v-textarea name="prerequisite" rows="2" label="Prerequisites" value="Input text" v-model="trainerPackage.prerequisite" :rules="rules.prerequisite" :counter="512" box required></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-btn round color="primary" outline @click.native="downloadDocument(trainerPackage.outlineDocument)"
              v-if="trainerPackage.outlineDocument !== ''"
              >Preview course outline
              </v-btn>
              <label class="primary--text">
                <span v-if="trainerPackage.outlineDocument !== ''"> -or- </span>
                <span v-else>(Optional) </span>
                Upload <span v-show="trainerPackage.outlineDocument !== ''">New</span> Course Outline:</label>
              <input ref="fileUploadButton" name="outlineDocumentFile" type="file" class="file" data-show-upload="true" data-show-caption="true" data-show-preview="true" accept="application/pdf, application/vnd.apple.pages, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation">
            </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
import DocumentUploadCard from '@/components/DocumentUploadCard'
export default {
  name: 'Packages',
  components: {
    DocumentUploadCard
  },
  watch: {
    dialogOpen (val) {
      if (val) {
        this.$refs.fileUploadButton.value = ''
      }
    }
  },
  data () {
    return {
      deleteDialogOpen: false,
      items: [
        {
          text: 'Instructor Led Training (ILT)',
          value: 5
        },
        {
          text: 'Personalized Self Learning (PSL)',
          value: 6
        }
      ],
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        packageTitle: [
          (v) => !!v || 'Trainer Package Title is required',
          (v) => (v && v.length <= 128) || 'TrainerPackage Title must be less than 128 characters'
        ],
        packageSummary: [
          (v) => !!v || 'Trainer Package Summary is required',
          (v) => (v && v.length <= 512) || 'Trainer Package Summary must be less than 512 characters'
        ],
        packageGoals: [
          (v) => !!v || 'Trainer Package Goals is required',
          (v) => (v && v.length <= 512) || 'Trainer Package Goals must be less than 512 characters'
        ],
        targetAudience: [
          (v) => !!v || 'Target Audience is required',
          (v) => (v && v.length <= 128) || 'Target Audience must be less than 128 characters'
        ],
        targetIndustry: [
          (v) => !!v || 'Target Industry is required',
          (v) => (v && v.length <= 128) || 'Target Industry must be less than 128 characters'
        ],
        duration: [
          (v) => !!v || 'Duration is required',
          (v) => (v && v <= 1000) || 'Duration must be of less than 3 digits',
          (v) => (/^\d+$/.test(v)) || 'Duration must be only number'
        ],
        unitPrice: [
          (v) => !!v || 'Unit Price is required',
          (v) => (v && v.length <= 32) || 'Unit Price must be less than 32 characters'
        ],
        keyTopics: [
          (v) => !!v || 'Key Topics is required',
          (v) => (v && v.length <= 128) || 'Key Topics must be less than 128 characters'
        ],
        keySkills: [
          (v) => !!v || 'Key Skills is required',
          (v) => (v && v.length <= 256) || 'Key Skills must be less than 256 characters'
        ],
        assessmentMethodology: [
          (v) => !!v || 'Assessment/Methodology is required',
          (v) => (v && v.length <= 512) || 'Assessment/Methodology must be less than 512 characters'
        ],
        prerequisite: [
          (v) => !!v || 'Prerequisite is required',
          (v) => (v && v.length <= 512) || 'Prerequisite must be less than 512 characters'
        ]
      },
      dialogOpen: false
    }
  },
  created () {
    Store.dispatch('profile/getTrainerPackageList')
  },
  computed: {
    ...mapState('profile', {
      trainerPackage: 'trainerPackage',
      trainerPackageList: 'trainerPackageList',
      loading: 'loading'
    }),
    title () {
      if (this.trainerPackage.id === null) return 'Add Training Package'
      else return 'Edit Training Package'
    }
  },
  methods: {
    trainingTypeString (id) {
      if (id === 5) {
        return 'Instructor Led Training'
      } else if (id === 6) {
        return 'Personalized Self Learning'
      }
    },
    downloadDocument (url) {
      Store.dispatch('profile/downloadDocument', url)
    },
    cb () {
      this.$refs.trainerPackageForm.reset()
      this.dialogOpen = false
      this.deleteDialogOpen = false
    },
    editTrainerPackage (trainerPackage) {
      Store.dispatch('profile/updateTrainerPackageForm', { ...trainerPackage })
      this.dialogOpen = true
    },
    addTrainerPackage () {
      Store.dispatch('profile/updateTrainerPackageForm', null)
      // this.cb()
      this.$refs.trainerPackageForm.reset()
      this.dialogOpen = true
    },
    async deleteTrainerPackage () {
      await Store.dispatch('profile/deleteTrainerPackage', {id: this.trainerPackage.id, cb: this.cb})
    },
    async saveTrainerPackage () {
      if (this.$refs.trainerPackageForm.validate()) {
        console.log('form data testing going on')
        let formData = new FormData(document.getElementById('tpForm'))
        formData.set('trainigType', this.trainerPackage.trainigType)
        // Display the key/value pairs
        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }
        // if (formData.get('outlineDocumentFile').size === 0) {
        //   formData.set('outlineDocumentFile', null)
        // }
        await Store.dispatch('profile/saveTrainerPackage', { formData, cb: this.cb })
        // this.cb()
        // this.dialogOpen = false
      }
    },
    cancelForm () {
      Store.dispatch('profile/updateTrainerPackageForm', null).then(this.cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Packages.vue